/**
 * Тарифы держим в ядре: одна и та же цена нужна серверу (сумма в Kaspi),
 * витрине и отчётам. Расходиться им негде.
 */
export const TIERS = ['FULL', 'PRO'];
/** Цена в тенге. Kaspi принимает сумму как число, копеек в тенге нет. */
export const TIER_PRICE = {
    FULL: 14_990,
    PRO: 29_990,
};
/**
 * PRO продаётся только когда готова персональная книга пары: брать деньги
 * за то, чего ещё нет, нельзя. Флаг снимается вместе с выпуском NEKE KITAP.
 */
export const TIER_ON_SALE = {
    FULL: true,
    PRO: false,
};
export const SALE_TIERS = TIERS.filter((tier) => TIER_ON_SALE[tier]);
export function isTier(value) {
    return typeof value === 'string' && TIERS.includes(value);
}
/** PRO включает всё, что даёт FULL, поэтому доступ проверяется по набору. */
export function tierGrants(paid) {
    return paid === 'PRO' ? ['FULL', 'PRO'] : ['FULL'];
}
//# sourceMappingURL=pricing.js.map